import React, { useState, useRef } from "react";
import Layout from "../../layout/Layout";
import { Box, Button, Card, CardContent, TextField, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import UserAPI from "../../services/profile-api";

import html2pdf from "html2pdf.js";

import styles from "./QRCode.module.scss";
import Swal from "sweetalert2";
import FilterLoader from "../../components/Loader/FilterLoader";

export default function QRCode() {
  const [loading, setLoading] = useState(false);
  const [utmCode, setUtmCode] = useState("");
  const [imageUrl, setImageUrl] = useState(null);

  const contentRef = useRef(null);

  const { generateQRCodeAPI } = new UserAPI();

  const handleQRCodeAPI = async () => {
    if (utmCode) {
      setLoading(true);
      const res = await generateQRCodeAPI(utmCode);

      if (res.ok) {
        const data = res.data.qrCode;
        setImageUrl(data);

        setTimeout(() => {
          handleGeneratePdf();
          setImageUrl(null);
          setUtmCode("");
        }, 0);
      }

      setLoading(false);
    } else {
      Swal.fire({
        icon: "warning",
        text: "Please Enter UTM Code",
        showConfirmButton: false,
        timer: 2000,
      });
    }
  };

  const handleGeneratePdf = () => {
    const element = contentRef.current;

    html2pdf()
      .from(element)
      .toPdf()
      .get("pdf")
      .then(function (pdf) {
        const pdfBlob = pdf.output("blob");
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, "_blank");
      });
  };

  return (
    <Layout>
      <Card elevation={0} sx={{ py: 1, borderRadius: 3 }}>
        <CardContent>
          <Box className="header-title" sx={{ mb: 2 }}>
            <Typography variant="h4">Generate QR Code</Typography>
          </Box>

          <Grid container spacing={3}>
            <Grid size={4}>
              <TextField
                fullWidth
                autoComplete="off"
                size="small"
                name="firstName"
                label="Enter UTM Code"
                variant="outlined"
                value={utmCode}
                onChange={(e) => setUtmCode(e.target.value)}
              />

              <Button
                color="primary"
                variant="contained"
                type="submit"
                size="large"
                sx={{
                  "&.Mui-disabled": {
                    color: "#000",
                    background: "#ddddddd",
                  },
                  width: 200,
                  marginTop: 3,
                }}
                onClick={() => handleQRCodeAPI()}
              >
                SUBMIT
              </Button>
            </Grid>
          </Grid>

          {imageUrl && (
            <div ref={contentRef} className={styles.pdfContainer}>
              <img src="/images/qr-code.png" className={styles.qrCodeImage} alt="" />
              {imageUrl && <img src={imageUrl} className={styles.qrCode} alt="" />}
              <p className={styles.utmCode}>{utmCode}</p>
            </div>
          )}
        </CardContent>
      </Card>

      {loading && <FilterLoader />}
    </Layout>
  );
}
